import type { AxiosInstance } from 'axios';
import { createCrudService, type CrudService } from '../core/crud';
import type { RecipeIngredient, RecipeIngredientCreate, RecipeIngredientFilter } from '../data/recipeIngredient';

export function createRecipeIngredientService(client: AxiosInstance) {
  return createCrudService<RecipeIngredient, RecipeIngredientCreate, RecipeIngredientFilter>(
    client,
    '/restaurant/RecipeIngredient',
    'id',
  );
}

export type RecipeIngredientService = CrudService<RecipeIngredient, RecipeIngredientCreate, RecipeIngredientFilter>;
